import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";
import { DRAWER_WIDTH, FOOTER_HEIGHT } from "src/utils/constants";

export const LayoutStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
    },
    content: {
      flexGrow: 1,
      marginTop: window.location.pathname === "/entity-onboarding" ? "0px" : "20px",
      minHeight: `calc(100vh - ${FOOTER_HEIGHT}px)`,
      background: theme.palette.background.paper,
      // marginLeft: theme.spacing(7) + 1,
      // marginLeft: 0,
      [theme.breakpoints.up("md")]: {
        marginTop: window.location.pathname === "/entity-onboarding" ? "0px" : "20px",
        marginLeft: "220px",
      },
    },
    contentShift: {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: `calc(100vw - ${DRAWER_WIDTH}px)`,
    },
    hide: {
      display: "none",
    },
  }),
);
